export default function isNil(o) {
  return o === null || o === undefined
}